/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */
import { FC, useMemo } from 'react'

import {
  useCurrentUser,
  CommentItem,
  User,
  getUserByEmploymentId,
} from '@builddocs/data-management'
import { UserCardInCommentCard } from '@builddocs/mui'
import { Checkbox, Stack, Typography } from '@mui/material'
import { AxiosError } from 'axios'
import { useQuery } from 'react-query'

interface OwnProps {
  selected: boolean
  comment: CommentItem
  onSelect: () => void
  selecting: boolean
}

type Props = OwnProps

export const CommentHistoryCard: FC<Props> = ({
  comment,
  onSelect,
  selected,
  selecting,
}) => {
  const { user } = useCurrentUser()
  const canEdit = useMemo(
    () => user.employment.employmentId === comment.employmentId,
    [user, comment],
  )

  /** Получение User по employmentId */
  const { data: userFromComment } = useQuery<User, AxiosError>(
    ['userByEmploymentId', comment.employmentId],
    async () =>
      canEdit ? user : await getUserByEmploymentId(comment.employmentId),
  )

  return (
    <Stack direction="row" gap={1}>
      {selecting && (
        <Checkbox
          checked={selected}
          size="medium"
          sx={{
            width: 'fit-content',
            height: 'fit-content',
            flex: '0 0',
          }}
          onChange={onSelect}
        />
      )}
      <Stack spacing={1}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          {userFromComment && (
            <UserCardInCommentCard comment={comment} user={userFromComment} />
          )}
          <Stack alignItems="center" direction="row" spacing={1} />
        </Stack>
        <Typography pl={5}>{comment.problemDescription}</Typography>
        {comment.information && (
          <Typography pl={5} variant="body2">
            <Typography
              color="text.secondary"
              component="span"
              variant="inherit"
            >
              Место в документе:
            </Typography>
            {` ${comment.information}`}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}

export default CommentHistoryCard
